import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementIncidentTypeAddComponent } from './case-management-incident-type-add.component';

const routes: Routes = [{ path: '', component: CaseManagementIncidentTypeAddComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementIncidentTypeAddRoutingModule { }
